export default {
    name: 'navigation',
    state: {
        navigationId: ""
    },
    getters: {
        getNavigationId: state => {
            return state.navigationId
        },
    },
    mutations: {
        ACTIVE_NAVIGATION: (state, payload) => {
            state.navigationId = payload;
        }
    },
    actions: {
        SET_ACTIVE_NAVIGATION(store, payload) {
            store.commit('ACTIVE_NAVIGATION', payload)
        }
    }
}